import clsx from 'clsx';
import React from 'react';

export type PaneProps = {
  split?: 'vertical' | 'horizontal';
  className?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  size?: string | number;
  eleRef?: (e: HTMLDivElement | null) => void;
};

export const Pane = React.memo(function PaneComponent(props: PaneProps) {
  const { children, className, split, style, size, eleRef } = props;

  const newStyle = React.useMemo(() => {
    const result: React.CSSProperties = {
      flex: 1,
    };

    if (size !== undefined) {
      if (split === 'vertical') {
        result.width = size;
      } else {
        result.height = size;
        result.display = 'flex';
      }
      result.flex = 'none';
    }

    return {
      ...result,
      ...(style ?? {}),
    };
  }, [size, split, style]);

  return (
    <div ref={eleRef} className={clsx('Pane', split, className)} style={newStyle}>
      {children}
    </div>
  );
});
